export const handler = (el, e) => {
  const target = document.querySelector(el.getAttribute("href"));
  if (!target) {
    return;
  }
  e.preventDefault();
  // @TODO: DO things with this!
};
